export const navLogo = {
    img: require('../../images/svg_1.svg'),
    alt: 'Expert'
}